import { FormattedMessage, injectIntl } from "react-intl";
import { Component } from "react";
import { Formik } from "formik";
import {
  redirectTo,
  navigateTo,
  isEmpty,
  TextInput,
  SubmitButton,
  CancelButton,
  ActionBar,
  ActionBarButtons,
  EditActionButton,
  errorsShape,
  planCartShape,
  handleUnknownErrors,
  showSuccess,
  ApiErrorsHandler,
  Loader,
  loadSubscriptionPlanCart,
  updatePlanCartParameters,
  apiErrorsContain,
  upgradePlanCart,
  showError,
  ConfirmationModal,
  chooseRelevantCountryCode,
  addonIsOnBlacklist,
  CONFIGURATION,
  intlShape,
  htmlFormat,
  htmlLink,
  backendShape,
  withBackend,
} from "lcm-iot-commons";

import SubscriptionPaymentEditModal from "lcm-iot-commons/client/lib/components/Subscriptions/SubscriptionPaymentEditModal";
import SubscriptionInvoiceEstimate from "lcm-iot-commons/client/lib/components/Subscriptions/SubscriptionInvoiceEstimate";
import SubscriptionPaymentDetails from "lcm-iot-commons/client/lib/components/Subscriptions/SubscriptionPaymentDetails";
import SubscriptionBillingDetails from "lcm-iot-commons/client/lib/components/Subscriptions/SubscriptionBillingDetails";
import { loadConnectSubscription, loadCurrentSubscription } from "../../api";

type OwnProps = {
  backend: backendShape;
  match?: {
    params?: {
      id?: string;
      edgeDeviceId?: string;
    };
  };
  dispatch?: $TSFixMeFunction;
  planCart?: planCartShape;
  updating?: boolean;
  checkedout?: boolean;
  handleSubmit?: $TSFixMeFunction;
  intl?: intlShape;
  errors?: errorsShape;
  couponCode?: string;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  match: undefined,
  dispatch: undefined,
  planCart: undefined,
  updating: undefined,
  checkedout: undefined,
  handleSubmit: undefined,
  intl: undefined,
  errors: undefined,
  couponCode: undefined,
};

type Props = OwnProps & typeof defaultProps;

export class ConnectSubscriptionCheckout extends Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  static readonly defaultProps = defaultProps;

  // eslint-disable-next-line react/no-unused-class-component-methods
  form: $TSFixMe;

  submitCallback: $TSFixMe;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnDeleteDiscountCode =
      this.handleOnDeleteDiscountCode.bind(this);
    this.onSubmitCoupon = this.onSubmitCoupon.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.onConfirmModal = this.onConfirmModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onPaymentEditAccept = this.onPaymentEditAccept.bind(this);
    this.onPaymentEditDecline = this.onPaymentEditDecline.bind(this);
    this.onChangeToPaymentPerInvoiceAccept =
      this.onChangeToPaymentPerInvoiceAccept.bind(this);
    this.onChangeToPaymentPerInvoiceDecline =
      this.onChangeToPaymentPerInvoiceDecline.bind(this);
    this.onPaymentUpdateToInvoice = this.onPaymentUpdateToInvoice.bind(this);
    this.state = {
      loading: true,
      isDeleting: false,
      checkingOut: false,
      addonsNotAllowed: [],
      showPaymentEditModal: false,
      showUpdatePaymentModal: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async handleOnDeleteDiscountCode() {
    const { intl } = this.props;
    this.setState({ isDeleting: true });
    try {
      const planCartWithoutVoucher = await updatePlanCartParameters({
        coupon_code: null,
      });
      this.setState({ planCart: planCartWithoutVoucher, isDeleting: false });
    } catch (errors) {
      handleUnknownErrors(
        errors,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({ id: "api.error.unknown" }),
      );
      this.setState({ isDeleting: false });
    }
  }

  async handleOnSubmit() {
    const { intl } = this.props;
    this.setState({ checkingOut: true });
    try {
      await upgradePlanCart();
      showSuccess(
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({ id: "subscription_checkout.success_message" }),
      );
      navigateTo("/subscriptions/connect");
    } catch (error) {
      if (apiErrorsContain(error, "payment_failed")) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        showError(intl.formatMessage({ id: "api.error.payment_failed" }));
      } else {
        handleUnknownErrors(
          error,
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({ id: "api.error.unknown" }),
        );
      }
    }
  }

  onConfirmModal() {
    const { match } = this.props;
    this.setState({ showModal: false });
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    navigateTo(`/subscriptions/connect/${match.params.id}/upgrade`);
  }

  onChangeToPaymentPerInvoiceAccept() {
    const { intl } = this.props;
    this.onChangeToPaymentPerInvoice().catch((apiErrors) => {
      this.setState((prevState: $TSFixMe) => ({
        planCart: prevState.oldPlanCart,
        fetching: false,
      }));
      handleUnknownErrors(
        apiErrors,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({ id: "api.error.unknown" }),
      );
    });
  }

  async onChangeToPaymentPerInvoice() {
    const { intl, match, backend } = this.props;
    // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
    const oldPlanCart = this.state.planCart;
    this.setState({
      showUpdatePaymentModal: false,
      planCart: undefined,
      oldPlanCart,
      fetching: true,
    });
    await backend.patch(
      `/api_subscriptions/${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        match.params.id
      }/payment/to_invoice`,
    );
    const planCart = await loadSubscriptionPlanCart();
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const subscription = await loadConnectSubscription(match.params.id);
    const subscriptionFromBackend = await loadCurrentSubscription(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      match.params.id,
      true,
    );
    this.setState({
      planCart,
      subscriptionFromBackend,
      subscription,
      fetching: false,
    });
    showSuccess(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      intl.formatMessage({
        id: "payment_details_edit.change_to_invoice.success_message",
      }),
    );
  }

  onPaymentEditDecline() {
    this.setState({ showPaymentEditModal: false });
  }

  onPaymentEditAccept() {
    const { match } = this.props;
    this.setState({ showPaymentEditModal: false });
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    redirectTo(`/payment/update/checkout/${match.params.id}`);
  }

  onPaymentUpdateToInvoice() {
    this.setState({
      showPaymentEditModal: false,
      showUpdatePaymentModal: true,
    });
  }

  onCloseModal() {
    this.setState({ showModal: false });
  }

  onChangeToPaymentPerInvoiceDecline() {
    this.setState({ showUpdatePaymentModal: false });
  }

  async onSubmitCoupon(
    data: $TSFixMe,
    /* istanbul ignore next */ actions = {},
  ) {
    const { intl } = this.props;
    try {
      const planCartWithVoucher = await updatePlanCartParameters({
        coupon_code: data.couponCode,
      });
      this.setState({ planCart: planCartWithVoucher });
    } catch (errors) {
      const formErrors = {};
      this.setState({ checkingOut: false });
      // @ts-expect-error TS(2345) FIXME: Argument of type '"coupon_code"' is not assignable... Remove this comment to see the full error message
      if (apiErrorsContain(errors, "invalid_input", "coupon_code")) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        (formErrors as $TSFixMe).couponCode = intl.formatMessage({
          id: "api.error.coupon_code.invalid_input",
        });
      } else {
        handleUnknownErrors(
          errors,
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({ id: "api.error.unknown" }),
        );
      }
      (actions as $TSFixMe).setErrors(formErrors);
    }
    (actions as $TSFixMe).setSubmitting(false);
  }

  async loadData() {
    const { match } = this.props;
    const planCart = await loadSubscriptionPlanCart();
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const subscription = await loadConnectSubscription(match.params.id);
    const subscriptionFromBackend = await loadCurrentSubscription(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      match.params.id,
      true,
      true,
    );
    const addonsNotAllowed = addonIsOnBlacklist(
      planCart.addons,
      chooseRelevantCountryCode(subscription),
    );
    this.setState({
      planCart,
      subscription,
      subscriptionFromBackend,
      loading: false,
      addonsNotAllowed,
      showModal: addonsNotAllowed.length > 0,
    });
  }

  validateForm(values: $TSFixMe) {
    const { intl } = this.props;
    const errors = {};
    /* istanbul ignore next */
    if (isEmpty(values.couponCode) || isEmpty(values.couponCode.trim())) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      (errors as $TSFixMe).couponCode = intl.formatMessage({
        id: "api.error.coupon_code.invalid_input",
      });
    }
    return errors;
  }

  renderForm(props: $TSFixMe) {
    const { intl } = this.props;
    const { planCart, isDeleting } = this.state;
    const { handleSubmit, isSubmitting, setStatus } = props;
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.form = props;

    /* istanbul ignore next */
    const beforeHandleSubmit = (event: $TSFixMe) => {
      /* istanbul ignore next */
      setStatus("submitted");
      /* istanbul ignore next */
      handleSubmit(event);
    };

    const deleteCouponButton =
      planCart && planCart.couponCode ? (
        <SubmitButton
          id="delete_coupon_code_button"
          fetching={isDeleting}
          hero={false}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          text={intl.formatMessage({
            id: "subscription_checkout.delete_button",
          })}
          onClick={this.handleOnDeleteDiscountCode}
        />
      ) : /* istanbul ignore next */ null;

    const enterCouponCode =
      planCart && !planCart.couponCode ? (
        /* istanbul ignore next */ <form
          onSubmit={beforeHandleSubmit}
          noValidate
        >
          <div className="row">
            <div className="col-xs-12">
              <TextInput
                {...props}
                id="coupon_code"
                name="couponCode"
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                label={intl.formatMessage({
                  id: "subscription_checkout.coupon_code",
                })}
              />
            </div>
          </div>
          <div className="btn-group">
            <SubmitButton
              id="apply_coupon_code_button"
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              text={intl.formatMessage({
                id: "subscription_checkout.apply_button",
              })}
              hero={false}
              disabled={!props.dirty}
              fetching={isSubmitting}
            />
          </div>
        </form>
      ) : null;

    return (
      <div>
        {enterCouponCode}
        {deleteCouponButton}
      </div>
    );
  }

  render() {
    const {
      planCart,
      subscription,
      subscriptionFromBackend,
      loading,
      checkingOut,
      showModal,
      addonsNotAllowed,
      showPaymentEditModal,
      showUpdatePaymentModal,
      fetching,
    } = this.state;
    const { intl, match } = this.props;
    const errors: $TSFixMe = [];
    let paymentDetailsValid = null;
    let canUpgrade = null;

    if (subscriptionFromBackend) {
      paymentDetailsValid =
        (subscriptionFromBackend.cardPaymentDetails &&
          subscriptionFromBackend.cardPaymentDetails.valid) ||
        (subscriptionFromBackend.invoicePaymentDetails &&
          subscriptionFromBackend.invoicePaymentDetails.filter(
            (i: $TSFixMe) =>
              i.status && (i.status === "posted" || i.status === "payment_due"),
          ).length === 0);
      canUpgrade =
        (subscriptionFromBackend.cardPaymentDetails &&
          subscriptionFromBackend.cardPaymentDetails.valid) ||
        subscriptionFromBackend.invoicePaymentDetails;
    }

    const canChangeToInvoice =
      subscription &&
      (subscription.status === "confirmed" ||
        subscription.status === "scheduled_update" ||
        subscription.status === "open");

    const paymentEditModal =
      subscriptionFromBackend && showPaymentEditModal ? (
        <SubscriptionPaymentEditModal
          onAccept={this.onPaymentEditAccept}
          onChange={this.onPaymentUpdateToInvoice}
          onDecline={this.onPaymentEditDecline}
          canChangeToInvoice={canChangeToInvoice}
          isCredit={subscriptionFromBackend.invoicePaymentDetails === null}
        />
      ) : null;

    const modalChangeToInvoice = subscriptionFromBackend ? (
      <ConfirmationModal
        id="modal-dialog-invoice"
        show={showUpdatePaymentModal}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        titleText={intl.formatMessage({
          id: "payment_details_edit.change_credit_to_invoice",
        })}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        messageText={intl.formatMessage({
          id: "payment_details_edit.change_to_invoice_description",
        })}
        onConfirm={this.onChangeToPaymentPerInvoiceAccept}
        onClose={this.onChangeToPaymentPerInvoiceDecline}
      />
    ) : null;

    const invoiceEstimateDetails =
      planCart && !loading ? (
        <div id="subscription-checkout-invoice-estimate" className="row">
          <div className="col-md-12">
            <ActionBar>
              <h2>
                <FormattedMessage id="subscription_checkout.invoice_estimate_header" />
              </h2>
            </ActionBar>
            <SubscriptionInvoiceEstimate
              // @ts-expect-error TS(2322) FIXME: Type '{ invoiceEstimate: any; }' is not assignable... Remove this comment to see the full error message
              invoiceEstimate={planCart.invoiceEstimate}
            />
          </div>
        </div>
      ) : null;

    const couponCodeDetailsFormik =
      planCart && planCart.couponIsAllowed && !loading ? (
        <div className="row">
          <div className="col-md-4">
            <Formik
              onSubmit={this.onSubmitCoupon}
              validate={this.validateForm}
              initialValues={{}}
            >
              {this.renderForm}
            </Formik>
          </div>
        </div>
      ) : null;

    const subscriptionBillingDetails =
      planCart && !loading ? (
        <div id="subscription-billing-details" className="row">
          <div className="col-md-12">
            <ActionBar>
              <h2>
                <FormattedMessage id="subscription_checkout.billing_details_header" />
              </h2>
              <ActionBarButtons>
                <EditActionButton
                  disabled={!paymentDetailsValid}
                  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                  target={`/subscriptions/connect/${match.params.id}/edit/checkout`}
                />
              </ActionBarButtons>
            </ActionBar>
            <SubscriptionBillingDetails
              // @ts-expect-error TS(2322) FIXME: Type '{ billingAddress: any; shippingAddress: any;... Remove this comment to see the full error message
              billingAddress={subscription.billingAddress}
              shippingAddress={subscription.shippingAddress}
              customerPurchaseOrder={subscription.customerPurchaseOrder}
            />
          </div>
        </div>
      ) : null;

    const paymentDetails =
      planCart && !loading ? (
        <div id="subscription-checkout-payment-details" className="row">
          <div className="col-md-12">
            <ActionBar>
              <h2>
                <FormattedMessage id="subscription_checkout.payment_details_header" />
              </h2>
              <ActionBarButtons>
                <EditActionButton
                  id="payment-method-edit"
                  onClick={() => this.setState({ showPaymentEditModal: true })}
                  disabled={checkingOut || !paymentDetailsValid}
                />
              </ActionBarButtons>
            </ActionBar>
            {paymentEditModal}
            <SubscriptionPaymentDetails
              // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape | undefined; cardPaymentDe... Remove this comment to see the full error message
              intl={intl}
              cardPaymentDetails={subscriptionFromBackend.cardPaymentDetails}
              invoicePaymentDetails={
                subscriptionFromBackend.invoicePaymentDetails
              }
              onChangeToPaymentPerInvoice={
                this.onChangeToPaymentPerInvoiceAccept
              }
              canChangeToInvoice={canChangeToInvoice}
              source="checkout"
            />
          </div>
        </div>
      ) : null;

    const submitButton =
      planCart && !loading ? (
        <div>
          <div className="row">
            <div className="col-md-12 space-before">
              <div className="btn-group">
                <SubmitButton
                  id="upgrade_button"
                  fetching={checkingOut}
                  disabled={
                    checkingOut || !canUpgrade || addonsNotAllowed.length > 0
                  }
                  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                  text={intl.formatMessage({
                    id: "subscription_checkout.submit_button",
                  })}
                  onClick={this.handleOnSubmit}
                />
                <CancelButton
                  // @ts-expect-error TS(2322) FIXME: Type '{ intl: intlShape | undefined; id: string; d... Remove this comment to see the full error message
                  intl={intl}
                  id="cancel_button"
                  disabled={checkingOut || !paymentDetailsValid}
                  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                  target={`/subscriptions/connect/${match.params.id}/upgrade`}
                />
              </div>
            </div>
          </div>
        </div>
      ) : null;

    const mtext = (
      <div>
        <FormattedMessage
          id="subscription_create.addon_country_modal_dialog.message"
          values={{
            ...htmlFormat,
            notAllowedAddons: addonsNotAllowed.join(", "),
            // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
            a: htmlLink({
              href: CONFIGURATION.HELP_URL_AVAILABILITY,
              target: "_blank",
            }),
          }}
        />
      </div>
    );

    const addonModal =
      showModal && !loading ? (
        <ConfirmationModal
          id="addon-country-not-allowed-modal-dialog"
          show={showModal}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          titleText={intl.formatMessage({
            id: "subscription_create.addon_country_modal_dialog.title",
          })}
          messageText={mtext}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          buttonConfirmText={intl.formatMessage({
            id: "subscription_create.addon_country_modal_dialog.button_close",
          })}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          buttonCancelText={intl.formatMessage({
            id: "subscription_create.addon_country_modal_dialog.button_confirm",
          })}
          onConfirm={this.onConfirmModal}
          onClose={this.onCloseModal}
        />
      ) : null;

    return (
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      <ApiErrorsHandler errors={errors} submitCallback={this.submitCallback}>
        <div id="subscription-checkout" className="container">
          <ActionBar>
            <h1>
              <FormattedMessage id="subscription_checkout.header" />
            </h1>
          </ActionBar>
          <Loader loading={!planCart || fetching} />
          {addonModal}
          {invoiceEstimateDetails}
          {modalChangeToInvoice}
          {couponCodeDetailsFormik}
          {subscriptionBillingDetails}
          {paymentDetails}
          {submitButton}
        </div>
      </ApiErrorsHandler>
    );
  }
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
export default withBackend(injectIntl(ConnectSubscriptionCheckout));
